import { render, staticRenderFns } from "./dingdWxlistUsa.vue?vue&type=template&id=019c927d&scoped=true"
import script from "./dingdWxlistUsa.vue?vue&type=script&lang=js"
export * from "./dingdWxlistUsa.vue?vue&type=script&lang=js"
import style0 from "./dingdWxlistUsa.vue?vue&type=style&index=0&id=019c927d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c927d",
  null
  
)

export default component.exports